import React from 'react'
import classnames from 'classnames/bind'

import GradientHeader from 'components/shared/GradientHeader'
import Layout from 'components/shared/Layout'
import { RichText } from 'components/typo'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const UniversalRichText = ({ className, gradientHeader, richText }) => {
  return gradientHeader ? (
    <GradientHeader
      {...gradientHeader}
      layoutType="smallInnerWrapper"
      className={cx(className)}
    >
      <RichText type="Text" text={richText} className={css.content} />
    </GradientHeader>
  ) : (
    <Layout type="wrapper" className={cx(className)}>
      <Layout type="innerWrapper">
        <RichText type="Text" text={richText} className={css.content} />
      </Layout>
    </Layout>
  )
}

UniversalRichText.defaultProps = {}

export default UniversalRichText
